export default [
  'Gratis adgang til Vehicle Care tjenesten',
  'Gratis marketing materiale',
  'Fremvist på \'Vælg et foretrukket værksted\'',
  'Specifik kontaktperson',
  'Ingen binding eller behov for at købe noget'
];